import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  insertCopyStyles: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
  noticeWrapper: {
    marginBottom: base(),
  },
  radio: {
    '&:not(:last-child)': {
      marginBottom: base(0.5),
    },
  },
});
